import { render, staticRenderFns } from "./HuggingFaceRepoInfoDialog.vue?vue&type=template&id=8ec2434c&scoped=true"
import script from "./HuggingFaceRepoInfoDialog.vue?vue&type=script&lang=js"
export * from "./HuggingFaceRepoInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./HuggingFaceRepoInfoDialog.vue?vue&type=style&index=0&id=8ec2434c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec2434c",
  null
  
)

export default component.exports